import { render, staticRenderFns } from "./PhoneNoCome.vue?vue&type=template&id=d0864492&scoped=true"
import script from "./PhoneNoCome.vue?vue&type=script&lang=js"
export * from "./PhoneNoCome.vue?vue&type=script&lang=js"
import style0 from "./PhoneNoCome.vue?vue&type=style&index=0&id=d0864492&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0864492",
  null
  
)

export default component.exports